import React from 'react'

const Footer = () => {
	return (
		<div className=" text-center px-10 ">
			<div className="border-t p-3 border-[#ffffff21] mx-3 "></div>
			<a
				href="https://jothocodes.com"
				target="_blank"
				rel="noreferrer"
				className="text-[#ffffff] text-base font-light hover:animate-pulse cursor-pointer tracking-wider"
			>
				Copyright © John Thomas
			</a>
			<br />
		</div>
	)
}

export default Footer
